import { INewsItem, TNewPageStates } from '../interfaces/INewsItem';

export const NEWS_PAGE_STATES: TNewPageStates[] = [
  'Press Releases',
  'Press Coverage',
  'Media Kit',
];

export const PRESS_RELEASES: INewsItem[] = [
  {
    date: 'September 21, 2021',
    href: 'https://www.claimsjournal.com/services/newswire/2021/09/21/306061.htm',
    title:
      'HOVER and USAA Work Together to Help Increase Speed of the Property Claims Experience',
    description:
      'HOVER, the technology platform that informs more accurate estimates and enables desk adjusting with up-to-date photos and comprehensive, dependable property measurements, today announced they are working with USAA to help digitize parts of the property claims process for the leading financial services company’s over 13 million members. USAA’s adoption of HOVER will provide greater convenience and will help save time with some inspections in the claims process.',
  },
  {
    date: 'January 12, 2021',
    href: 'https://www.prnewswire.com/news-releases/amica-mutual-insurance-joins-hover-and-corelogic-to-transform-underwriting-inspections-301205770.html',
    title:
      'Amica Mutual Insurance Joins HOVER and CoreLogic to Transform Underwriting Inspections',
    description:
      'Amica leverages complete data package from HOVER and CoreLogic Digital Hub Alliance to streamline workflow and save costs with "DIY" process.',
  },
  {
    date: 'November 17, 2020',
    href: 'https://www.prnewswire.com/news-releases/hover-secures-a-60m-customer-led-round-to-build-the-future-of-property-data-and-transform-the-homeowner-experience-301174692.html?tc=eml_cleartime',
    title:
      'HOVER Secures a $60M Customer-Led Round to Build the Future of Property Data and Transform the Homeowner Experience',
    description:
      'Top U.S. Carriers and Venture Arms Travelers, State Farm Ventures™ and Nationwide invest in HOVER Series D financing.',
  },
  {
    date: 'October 20, 2020',
    href: 'https://www.prnewswire.com/news-releases/hover-partners-with-srs-distribution-inc-to-deliver-efficiency-and-precision-to-contractors-301155313.html',
    title:
      'HOVER Partners with SRS Distribution, Inc. to Deliver Efficiency and Precision to Contractors',
    description:
      "Contractors in the SRS network now have access to HOVER's proprietary technology to unlock workflow efficiencies.",
  },
  {
    date: 'July 16, 2020',
    href: 'https://www.crawco.com/resources/crawford-company-enters-enterprise-partnership-with-hover-inc',
    title: 'Crawford & Company Enters Enterprise Partnership with HOVER',
    description:
      'Crawford & Company partners with HOVER to drive innovation in claims management and increase policyholder satisfaction.',
  },
  {
    date: 'October 23, 2019',
    href: 'https://www.prnewswire.com/news-releases/hancock-claims-consultants-partners-with-hover-to-provide-improved-roof-and-property-inspections-300943453.html',
    title:
      'Hancock Claims Consultants Partners with HOVER to Provide Improved Roof and Property Inspections',
    description:
      'Together, Hancock and HOVER will provide carriers the most accurate and complete property data package for estimating roof and property damage.',
  },
  {
    date: 'September 16, 2019',
    href: 'https://www.businesswire.com/news/home/20190916005451/en/Travelers-3-D-Technology-HOVER-Property-Damage-Inspections',
    title:
      'Travelers Uses 3-D Technology from HOVER to Help Make Property Damage Inspections Quicker and Safer',
    description:
      'The Travelers Companies, Inc. (NYSE: TRV) today announced it is using HOVER to assist in assessing property damage.',
  },
  {
    date: 'June 25, 2019',
    href: 'https://www.prnewswire.com/news-releases/pacesetter-claims-service-incorporates-hover-technology-to-expedite-claims-process-300874172.html',
    title:
      'Pacesetter Claims Service Incorporates HOVER Technology to Expedite Claims Process',
    description:
      'HOVER partners with Pacesetter Claims Service to allow adjusters to efficiently process more claims after a disaster so policyholders can get paid faster.',
  },
  {
    date: 'June 18, 2019',
    href: 'https://www.prnewswire.com/news-releases/us-adjusting-services-partners-with-hover-to-expedite-and-improve-claims-satisfaction-300870110.html',
    title:
      'U.S. Adjusting Services Partners with HOVER to Expedite and Improve Claims Satisfaction',
    description:
      'HOVER teams up with U.S. Adjusting Services, one of the top independent adjusting firms in the U.S., to increase efficiency and accuracy in resolving homeowner claims.',
  },
  {
    date: 'April 25, 2019',
    href: 'https://www.prnewswire.com/news-releases/hover-secures-another-25-million-to-fuel-first-digital-marketplace-in-renovations-300838293.html',
    title:
      'HOVER Secures Another $25 Million To Fuel First Digital Marketplace In Renovations',
    description:
      'Learn more about how this latest investment will be used to enable ecommerce for large home improvement projects for the first time.',
  },
  {
    date: 'February 12, 2019',
    href: 'https://www.prnewswire.com/news-releases/genpact-integrates-hovers-3d-technology-as-part-of-its-virtual-adjusting-property-claims-offering-300793997.html',
    title:
      "Genpact Integrates HOVER's 3D Technology as Part of its Virtual Adjusting Property Claims Offering",
    description:
      'HOVERs 3D technology will complement Genpact’s property claims solutions, reducing the costs and time associated with the claims inspection process by 15-20 percent.',
  },
  {
    date: 'February 7, 2019',
    href: 'https://www.prnewswire.com/news-releases/hover-named-to-the-2019-cb-insights-ai-100-list-of-most-innovative-artificial-intelligence-startups-300791459.html',
    title:
      'HOVER Named to the 2019 CB Insights AI 100 List of Most Innovative Artificial Intelligence Startups',
    description:
      'HOVER is recognized by CB Insights AI List 100 as a global leader for advancements in computer vision and machine learning.',
  },
  {
    date: 'February 5, 2019',
    href: 'https://hover.to/blog/hovers-new-design-pro-technology-redefines-exterior-home-renovations/',
    title:
      'HOVER’s New Design Pro Technology Redefines Exterior Home Renovations',
    description:
      'Discover how HOVER is redefining exterior home renovations with Design Pro, an interactive 3D design experience that allows you to create exterior designs within seconds.',
  },
  {
    date: 'February 21, 2018',
    href: 'https://hover.to/blog/hover-launches-first-market-solution-deliver-roof-squares-within-minutes/',
    title:
      'HOVER Launches First-in-Market Solution to Deliver Roof Squares Within Minutes',
    description:
      'HOVER Now provides a roof square estimate within minutes, allowing contractors to create a quote while still on site with a homeowner.',
  },
  {
    date: 'January 29, 2018',
    href: 'https://hover.to/blog/gv-standard-industries-home-depot-lead-series-b-hover-3d-technology-bringing-transparency-home-improvement-industry/',
    title:
      'GV, Standard Industries, and The Home Depot lead Series B for HOVER, the 3D technology bringing transparency to the home improvement industry',
    description:
      'HOVER, the platform that generates accurate, interactive 3D models of any property, today announced that the company has secured $25 million in Series B funding.',
  },
  {
    date: 'December 7, 2017',
    href: 'https://hover.to/blog/hover-lp-partner-bring-lp-smartside-products-exterior-contractors-via-hover-platform/',
    title:
      'HOVER and LP Partner to Bring LP SmartSide Products to Exterior Contractors via the HOVER Platform',
    description:
      'The LP® SmartSide® product line is now available on the HOVER platform, allowing contractors to show homeowners exactly what LP’s materials and colors will look like on their homes.',
  },
  {
    date: 'April 4, 2017',
    href: 'https://staging.hover.to/blog/hover-delivers-new-capabilities-to-the-home-improvement-market/',
    title: 'HOVER Delivers New Capabilities to the Home Improvement Market',
    description:
      'New features allow exterior contractors, insurance carriers and adjusters to be fully prepared with accurate measurements and to provide remote estimates.',
  },
];

export const PRESS_COVERAGE: INewsItem[] = [
  {
    date: 'June 26, 2019',
    href: 'https://www.claimsjournal.com/news/national/2019/06/26/291666.htm',
    title: 'HOVER Gaining Ground as Underwriting, Adjusting Tool',
  },
  {
    date: 'April 25, 2019',
    href: 'https://venturebeat.com/2019/04/25/hover-raises-25-million-to-turn-pictures-of-homes-into-3d-models/',
    title: 'HOVER raises $25 million to turn pictures of homes into 3D models',
  },
  {
    date: 'April 25, 2019',
    href: 'https://www.forbes.com/sites/alexknapp/2019/04/25/visualization-startup-hover-just-raised-another-25-million-to-digitize-home-renovation-planning/#2153a55e705e',
    title:
      'Visualization Startup HOVER Just Raised Another $25 Million To Digitize Home Renovation Planning',
  },
  {
    date: 'February 25, 2019',
    href: 'https://news.crunchbase.com/news/home-depot-invests-in-roadies-37m-series-c-to-help-accelerate-product-deliveries/',
    title:
      'Home Depot Invests in Roadie’s $37M Series C To Help Accelerate Product Deliveries',
  },
  {
    date: 'February 18, 2019',
    href: 'https://www.propertycasualty360.com/2019/02/18/whos-using-what-in-pc-insurance-feb-18-2019/',
    title: 'Who’s using what in P&C insurance',
  },
  {
    date: 'February 12, 2019',
    href: 'https://www.forbes.com/sites/alexknapp/2019/02/12/a-real-fixer-apper-this-startup-builds-a-precise-3d-model-of-your-house-with-your-phone/',
    title:
      'A Real Fixer-Apper: This Startup Builds A Precise 3D-Model Of Your House With Your Phone',
  },
  {
    date: 'February 12, 2019',
    href: 'https://finance.yahoo.com/news/genpact-integrates-hovers-3d-technology-130000009.html',
    title:
      "Genpact Integrates HOVER's 3D Technology as Part of its Virtual Adjusting Property Claims' Offering",
  },
  {
    date: 'February 6, 2019',
    href: 'https://venturebeat.com/2019/02/06/cb-insights-here-are-the-top-100-ai-companies-in-the-world/',
    title: 'CB Insights: Here are the top 100 AI companies in the world',
  },
  {
    date: 'January 16, 2019',
    href: 'https://www.propertycasualty360.com/2019/01/16/four-trends-shaping-insurance-in-2019/',
    title: 'Four trends shaping insurance in 2019',
  },
  {
    date: 'January 10, 2019',
    href: 'https://blog.nari.org/2019/01/10/how-to-save-time-save-money-and-win-repeat-business-with-hover/',
    title: 'How to Save Time, Save Money and Win Repeat Business with HOVER',
  },
  {
    date: 'December 4, 2018',
    href: 'https://insurancenewsnet.com/innarticle/5-must-have-tech-tips-for-agents-and-brokers#.XAmBkhNKjBI',
    title: "5 'Must Have' Tech Tips For Agents And Brokers",
  },
  {
    date: 'October 2, 2018',
    href: 'https://www.symbilitysolutions.com/media/news-releases/symbility-the-first-claims-estimating-solution-on-the-market-to-fully-integrate-with-hovers-platform/',
    title:
      'Symbility Becomes The First Claims Estimating Solution On The Market To Fully Integrate With The HOVER Platform',
  },
  {
    date: 'September 13, 2018',
    href: 'https://www.prnewswire.com/news-releases/fourseventy-claim-management-partners-with-hover-to-help-streamline-claims-process-300712113.html',
    title:
      'Fourseventy Claim Management Partners with HOVER to Help Streamline Claims Process',
  },
  {
    date: 'June 20, 2018',
    href: 'https://asphaltlife.atlasroofing.com/article/atlas-launches-partnership-with-hover',
    title: 'Atlas Roofing Corporation Announces New Partnership with HOVER',
  },
  {
    date: 'June 7, 2018',
    href: 'https://www.propertycasualty360.com/2018/06/07/property-claims-customer-satisfaction-and-good-bus/',
    title: 'Property claims, customer satisfaction, and good business',
  },
  {
    date: 'April 12, 2018',
    href: 'https://www.prnewswire.com/news-releases/symbility-and-hover-collaborate-to-reduce-claims-adjusting-costs-and-decrease-cycle-times-300628460.html',
    title:
      'Symbility and HOVER Collaborate to Reduce Claims Adjusting Costs and Decrease Cycle Times',
  },
  {
    date: 'March 1, 2018',
    href: 'https://www.roofingcontractor.com/articles/92737-hover-launches-solution-to-deliver-roof-squares-within-minutes?id=92737-hover-launches-solution-to-deliver-roof-squares-within-minutes&ajs_uid=1027B8629690D3U&ajs_trait_oebid=3782E0258467B1M',
    title: 'HOVER Launches Solution To Deliver Roof Squares Within Minutes',
  },
  {
    date: 'February 26, 2018',
    href: 'https://news.certainteed.com/certainteed-and-hover-partner-to-help-contractors-to-visualize-properties-with-certainteed-roofing-and-siding-products/',
    title:
      'CertainTeed and HOVER Partner to Help Contractors Visualize Properties with CertainTeed Roofing and Siding Products',
  },
  {
    date: 'February 25, 2018',
    href: 'https://www.azobuild.com/news.aspx?newsID=22875',
    title: 'HOVER Product Delivers Roof Square Estimate Within Minutes',
  },
  {
    date: 'January 31, 2018',
    href: 'https://www.bizjournals.com/sanjose/news/2018/01/31/the-fundedbay-area-startups-haul-in-more-than-400.html',
    title:
      'The Funded: Bay Area startups haul in more than $400 million in venture funding at mid-week',
  },
  {
    date: 'January 30, 2018',
    href: 'http://www.finsmes.com/2018/01/hover-secures-25m-in-series-b-funding.html',
    title: 'HOVER Secures $25m in Series B Funding',
  },
  {
    date: 'January 29, 2018',
    href: 'https://www.wsj.com/articles/home-depot-backs-3-d-modeling-app-1517229000',
    title: 'Home Depot Backs 3-D Modeling App',
  },
  {
    date: 'January 29, 2018',
    href: 'https://techcrunch.com/2018/01/29/gv-leads-25m-investment-in-hover-a-computer-vision-startup-that-digitizes-your-home/',
    title:
      'GV leads $25M investment in HOVER, a computer vision startup that digitizes your home',
  },
  {
    date: 'August 1, 2017',
    href: 'http://qualifiedremodeler.epubxp.com/i/861097-aug-2017/14?m4=',
    title: 'Partnership adds product line to product',
  },
  {
    date: 'July 12 , 2017',
    href: 'https://residentialcontractormag.com/hover-lp-partner-bring-%E2%80%8Blp-smartside%E2%80%8B-products-exterior-contractors/',
    title: 'The LP® SmartSide® Now Available on the HOVER Platform',
  },
  {
    date: 'July, 2017',
    href: 'https://drive.google.com/open?id=0B6rr94pQdjFjb3lKZmozeV9ONHM',
    title: 'How Things Look (Vendor Profile)',
  },
  {
    date: 'July, 2017',
    href: 'http://digital.bnpmedia.com/publication/?i=419862#%7B%22issue_id%22:419862,%22page%22:70%7D',
    title: 'Product Focus - Software and Apps: HOVER',
  },
  {
    date: 'June 9, 2017',
    href: 'http://www.qualifiedremodeler.com/product/202763/platform-adds-features-to-professional-plan/?utm_source=QUR+Remodelers+Briefing&utm_medium=email&utm_campaign=RESCON170628002&o_eid=7333H3841412E3B',
    title: 'Platform adds features to professional plan',
  },
  {
    date: 'May 22, 2017',
    href: 'https://www.startupdelta.org/6-insur-tech-startups-win-diamond-award-at-digital-insurance-agenda-conference/',
    title:
      '6 Insur-Tech startups win Diamond Award at Digital Insurance Agenda Conference',
  },
  {
    date: 'April 18, 2017',
    href: 'http://www.constructiondive.com/news/new-tools-for-hover-app-aim-to-aid-prospecting/440765/',
    title: 'New tools for HOVER app aim to aid prospecting',
  },
  {
    date: 'April 17, 2017',
    href: 'http://www.roofingcontractor.com/articles/92196-hover-delivers-new-capabilities-to-the-home-improvement-market',
    title: 'HOVER Delivers New Capabilities to the Home Improvement Market',
  },
  {
    date: 'April 17, 2017',
    href: 'https://www.builderonline.com/building/structure-durability/hover-announces-two-new-features_o',
    title: 'HOVER announces two new features',
  },
  {
    date: 'May, 2016',
    href: 'http://mydigimag.rrd.com/publication/?i=300191',
    title: 'Digital Rx: An App a Day',
  },
  {
    date: 'May, 2016',
    href: 'http://qualifiedremodeler.epubxp.com/i/677646-may-2016',
    title: 'Beyond the Roof with Business Support',
  },
  {
    date: 'February 3, 2016',
    href: 'http://www.greenbuildermedia.com/blog/james-hardies-improved-hover-app-offers-special-perk-for-contractors-the-lowest-available-price-on-company-products',
    title:
      'James Hardie\'s Improved "HOVER" App Offers Special Perk for Contractors: The Lowest Available Price on Company Products',
  },
  {
    date: 'February 2, 2016',
    href: 'http://www.zlien.com/articles/top-11-apps-for-contractors-and-remodelers-in-2016/?utm_campaign=CFJ+Blog&utm_source=hs_email&utm_medium=email&utm_content=25874446&_hsenc=p2ANqtz-9Os0bKV5Zrk7ECFfjiLoHuxp7LXhnvMNi4AMogZ4Db1YlQq5FHIZtmREDPspP53LW2PAyuebytfFQp-MBh5Z_1qJRNug&_hsmi=25874446',
    title: 'Top 11 Apps for Contractors and Remodelers in 2016',
  },
  {
    date: 'February 1, 2016',
    href: 'https://www.builderonline.com/building/building-enclosure/new-app-eliminates-re-measuring-for-siding-projects_o',
    title: 'New App Eliminates Re-Measuring for Siding Projects',
  },
  {
    date: 'January 29, 2016',
    href: 'http://www.inthehouseshow.com/blog/blog-details/project-house-remodel-part-3.html',
    title: 'Project House Remodel - Part 3: Smart 3D rendering',
  },
  {
    date: 'January, 2016',
    href: 'http://qualifiedremodeler.epubxp.com/i/623311-jan-2016',
    title: 'Most Popular Products',
  },
  {
    date: 'November 23, 2015',
    href: 'https://www.remodeling.hw.net/videos/virtual-finishes-become-reality-with-the-hover-app',
    title: 'Virtual Finishes Become Reality with the HOVER App',
  },
  {
    date: 'November 19, 2015',
    href: 'https://blogs.wsj.com/venturecapital/2015/11/19/hover-raises-6-million-for-app-that-turns-photos-of-homes-into-3-d-models/',
    title:
      'HOVER Raises $6 Million for App That Turns Photos of Homes Into 3-D Models',
  },
  {
    date: 'October 15, 2015',
    href: 'https://constructioninformer.com/improve-construction-client-communication-and-win-more-jobs/',
    title: 'Improve Construction Client Communication and Win More Jobs',
  },
  {
    date: 'October 12, 2015',
    href: 'http://www.proremodeler.com/high-tech-help-sales',
    title: 'High-Tech Help for Sales',
  },
  {
    date: 'October 9, 2015',
    href: 'http://www.forresidentialpros.com/news-analysis/blog/20271207/remodeling-show-2015-perspectives-from-the-editors-of-qr',
    title: 'Remodeling Show 2015: Perspectives from the editors of QR',
  },
  {
    date: 'October 7, 2015',
    href: 'https://www.remodeling.hw.net/products/16-new-products-from-the-2015-remodeling-deck-jlc-live-show_o',
    title: '16 New Products from the 2015 Remodeling/Deck/JLC Live Show',
  },
  {
    date: 'October 6, 2015',
    href: 'http://www.greenbuildermedia.com/internet-of-things/from-iphone-to-dimensioned-3d-rendering',
    title: 'From iPhone to Dimensioned 3D Rendering',
  },
  {
    date: 'October 3, 2015',
    href: 'http://www.spreaker.com/user/onthehousewiththecareybrothers/on-the-house-october-03-2015_3',
    title: 'On The House With the Carey Brothers – Remodeling Show',
  },
  {
    date: 'June 15, 2012',
    href: 'http://techland.time.com/2012/06/15/better-than-3d-maps-from-apple-and-google-hover-aims-for-ground-level-detail-with-practical-value/',
    title:
      'Better than 3D Maps from Apple and Google? HOVER Aims for Ground-Level Detail with Practical Value',
  },
];
